import { logger as globalLogger, LogLevel } from '@empathy/logger';

export const logger = globalLogger.child('%cEmpathyX',
  'background-color:#c50953;color:#ffffff;border-radius:3px;padding:3px 10px;font-weight:bold');

const CONSOLE_LOG_LEVEL = 'ebx-consoleLogLevel';

logger.consoleLevel = parseInt(sessionStorage.getItem(CONSOLE_LOG_LEVEL), 0) || logger.consoleLevel;

export function setLoggerLogLevel(newLevel: LogLevel) {
  if (newLevel in LogLevel) {
    logger.consoleLevel = newLevel;
    sessionStorage.setItem(CONSOLE_LOG_LEVEL, newLevel.toString());
  }
}
